import { APIExtRoutes } from "@constants";
import { ReadClientDTO } from "@models/reviews/entities/client";

export class FamilyGroupConfigs {
  // Routes
  static readonly DefaultODataRoute = APIExtRoutes.odataFamilyGroups;

  // Table data
  static readonly PickColumns: (keyof ReadClientDTO)[] = [
    "id",
    "name",
    "status",
    "numberOfReviews",
    "adviserName",
    "adviserUserId",
    "adviserAvatarUrl",
  ];

  static readonly GlobalFilterColumns: (keyof ReadClientDTO)[] = [
    "name",
    "adviserName",
  ];
}
